import { CustomCell } from './components/custom-cell';
import { getNumericOperators } from '../../utils/getNumericOperators';
import { getStringOperators } from '../../utils/getStringOperators';

export const TABLE_COLUMNS = (fillers, states, modes) => [
	{
		headerName: '#',
		field: 'id',
		width: 100,
		minWidth: 100,
		align: 'center',
		headerAlign: 'center',
		type: 'number',
		cellClassName: 'id',
		filterOperators: getNumericOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Название',
		field: 'icepack',
		flex: 2,
		filterOperators: getStringOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Производитель',
		field: 'partner',
		flex: 2,
		sortable: false,
		filterOperators: getStringOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Наполнитель',
		field: 'filler_id',
		flex: 2,
		type: 'singleSelect',
		valueOptions: fillers,
		getOptionValue: value => value?.id,
		getOptionLabel: value => value?.name ?? 'Все',
		valueGetter: (value, row) => {
			if (!row.filler) {
				return 0;
			}

			return row.filler.id;
		},
	},
	{
		headerName: 'Состояние',
		field: 'state_id',
		flex: 2,
		type: 'singleSelect',
		valueOptions: states,
		getOptionValue: value => value?.id,
		getOptionLabel: value => value?.name ?? 'Все',
		valueGetter: (value, row) => {
			if (!row.state) {
				return 0;
			}

			return row.state.id;
		},
	},
	{
		headerName: 'Температурный режим',
		field: 'mode_id',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		sortable: false,
		type: 'singleSelect',
		valueOptions: modes,
		getOptionValue: value => value?.id,
		getOptionLabel: value => value?.name ?? 'Все',
		valueGetter: (value, row) => {
			if (!row.mode) {
				return 0;
			}

			return row.mode.id;
		},
	},
	{
		headerName: 'Масса, кг',
		field: 'weight',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
